export default import.meta.ROLLUP_FILE_URL_WF0jN26w;